import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoContextMenuMixin from './KendoContextMenuMixin'

export default {
    name: 'kendo-contextmenu',
    mixins: [ KendoContextMenuMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('ul', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoContextMenu/index.js